import { render, staticRenderFns } from "./ImportedLearningRequestItem.vue?vue&type=template&id=128c1cca&scoped=true&"
import script from "./ImportedLearningRequestItem.vue?vue&type=script&lang=ts&"
export * from "./ImportedLearningRequestItem.vue?vue&type=script&lang=ts&"
import style0 from "./ImportedLearningRequestItem.vue?vue&type=style&index=0&id=128c1cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128c1cca",
  null
  
)

export default component.exports